import { useCartContext } from '@/context/Cart/CartContext';
import { useGetCartDetails } from '@/hooks/cart/useGetCartDetails';
import { ForwardedRef, useEffect, useImperativeHandle, useState } from 'react';
import { CloseModalHandler } from '../CartModal';
import { cartDetailApiResponseToViewCartUi } from '../mapper';
import { initialState, ViewCartUi } from './ViewCartUiModel';

export function useViewCartBodyViewController(
  closeModalHandlerRef: ForwardedRef<CloseModalHandler>
) {
  const [uiState, setUiState] = useState<ViewCartUi>(initialState);
  const { openModal, setOpenModal } = useCartContext();
  const getCartDetailHook = useGetCartDetails();

  useImperativeHandle(closeModalHandlerRef, () => ({
    onCloseRequested: () => setOpenModal?.(undefined),
  }));

  useEffect(() => {
    if (!openModal) return;
    if (openModal.type === 'view') {
      getCartDetailHook.setCartId(openModal.cartId);
    }
  }, [openModal]);

  useEffect(() => {
    if (!getCartDetailHook.data) return;
    setUiState(cartDetailApiResponseToViewCartUi(getCartDetailHook.data));
  }, [getCartDetailHook.data]);

  return {
    uiState,
    actions: {},
  };
}
